import Icon from '../components/Icon.vue'

Icon.register({
  procedures: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 224c61.9 0 112 50.1 112 112v160c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-512v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-352c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v240h192v-144c0-8.8 7.2-16 16-16h256zM136 96c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h140.9c3.1 0 5.8 1.7 7.2 4.4l19.9 39.8 49.7-99.4c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2h102.1c8.8 0 16 7.2 16 16s-7.2 16-16 16h-121.9l-22.1-44.2-49.7 99.4c-5.9 11.8-22.7 11.8-28.6 0l-27.6-55.2h-126.1zM160 352c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'
      }
    ]
  }
})
